import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sprite-icon" }

import UseSvg from '@/components/UseSvg.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SpriteIcon',
  props: {
    name: null
  },
  setup(__props: any) {

const props = __props as {
    name: string
  };

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createVNode(UseSvg, {
      name: props.name
    }, null, 8, ["name"]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})